import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @file Drag 拖拽核心类型
 */
import { Emitter } from '@tencent/glue-util-emitter';
import { isClient } from '@tencent/glue-util-boundary';
export function getDefaultMousePos() {
  return {
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0
  };
}
var ALL_DRAG_ELEMENTS = []; // 当前激活的拖拽元素

var currentDragElement = null;

if (isClient()) {
  // 当前有激活元素时，屏蔽select、touch、click事件
  document.addEventListener('selectstart', function (e) {
    if (currentDragElement) {
      e.preventDefault();
    }
  }, false);
  document.addEventListener('touchstart', function (e) {
    if (currentDragElement) {
      e.preventDefault();
    }
  }, false);
  document.addEventListener('dragstart', function (e) {
    if (currentDragElement) {
      e.preventDefault();
    }
  }, false);
  document.addEventListener('click', function (e) {
    if (currentDragElement) {
      e.preventDefault();
    }
  }, false);
  document.addEventListener('mousemove', function (e) {
    if (currentDragElement) {
      currentDragElement.handleEvent(e);
    }
  }, false);
  document.addEventListener('mouseup', function (e) {
    if (currentDragElement) {
      currentDragElement.handleEvent(e);
    }
  }, false);
}

export var Drag = /*#__PURE__*/function (_Emitter) {
  _inherits(Drag, _Emitter);

  var _super = _createSuper(Drag);

  function Drag() {
    var _this;

    _classCallCheck(this, Drag);

    _this = _super.call(this);
    _this.elem = null;
    _this.dragLimit = 0;
    _this.trigger = '';
    _this.firstFlag = false;
    _this.startMousePos = getDefaultMousePos();
    _this.latestMousePos = getDefaultMousePos();

    _this.draggable = function () {
      return true;
    };

    ALL_DRAG_ELEMENTS.push(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Drag, [{
    key: "dispose",
    value: function dispose() {
      if (this === currentDragElement) {
        currentDragElement = null;
        this.handleDragEnd(this.latestMousePos);
      }

      var ele = this.getElem();
      ele && this.unbindEvent(ele);
      var index = ALL_DRAG_ELEMENTS.indexOf(this);

      if (index >= 0) {
        ALL_DRAG_ELEMENTS.splice(index, 1);
      }
    }
  }, {
    key: "init",
    value: function init(ele) {
      var originELe = this.getElem();
      this.elem = ele;

      if (originELe === ele) {
        return;
      }

      originELe && this.unbindEvent(originELe);
      ele && this.bindEvent(ele);
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(options) {
      var _options$draggable = options.draggable,
          draggable = _options$draggable === void 0 ? true : _options$draggable,
          _options$trigger = options.trigger,
          trigger = _options$trigger === void 0 ? '' : _options$trigger,
          data = options.data,
          _options$dragLimit = options.dragLimit,
          dragLimit = _options$dragLimit === void 0 ? 0 : _options$dragLimit;
      this.draggable = typeof draggable === 'function' ? draggable : function () {
        return draggable;
      };
      this.trigger = trigger;
      this.data = data;
      this.dragLimit = dragLimit;
    }
  }, {
    key: "getElem",
    value: function getElem() {
      return this.elem;
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      switch (e.type) {
        case 'mousedown':
          this.prepareDrag(e);
          break;

        case 'mousemove':
          this.handleDragging(e);
          break;

        case 'mouseup':
          this.handleDragEnd(e);
          break;
      }
    }
  }, {
    key: "prepareDrag",
    value: function prepareDrag(e) {
      e.stopPropagation();
      var trigger = this.trigger,
          draggable = this.draggable,
          data = this.data;

      if (!draggable() || trigger && !closest(e.target, trigger, this.getElem())) {
        return;
      }

      if (currentDragElement) {
        currentDragElement.handleDragEnd(e);
      }

      currentDragElement = this;
      this.firstFlag = true;
      var shiftKey = e.shiftKey,
          ctrlKey = e.ctrlKey,
          metaKey = e.metaKey,
          altKey = e.altKey,
          clientX = e.clientX,
          clientY = e.clientY,
          pageX = e.pageX,
          pageY = e.pageY;
      var startMousePos = this.startMousePos = {
        clientX: clientX,
        clientY: clientY,
        pageX: pageX,
        pageY: pageY
      };
      this.emit('drag-prepare', {
        shiftKey: shiftKey,
        ctrlKey: ctrlKey,
        metaKey: metaKey,
        altKey: altKey,
        startMousePos: startMousePos,
        currentMousePos: startMousePos,
        latestMousePos: startMousePos,
        data: data,
        target: this.getDragElem()
      });
    }
  }, {
    key: "handleDragStart",
    value: function handleDragStart(e) {
      this.firstFlag = false;
      var data = this.data,
          startMousePos = this.startMousePos;
      var shiftKey = e.shiftKey,
          ctrlKey = e.ctrlKey,
          altKey = e.altKey,
          metaKey = e.metaKey;
      this.emit('drag-start', {
        shiftKey: shiftKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        metaKey: metaKey,
        startMousePos: startMousePos,
        currentMousePos: startMousePos,
        latestMousePos: startMousePos,
        data: data,
        target: this.getDragElem()
      });
      this.latestMousePos = startMousePos;
    }
  }, {
    key: "handleDragging",
    value: function handleDragging(e) {
      e.stopPropagation();
      var clientX = e.clientX,
          clientY = e.clientY,
          pageX = e.pageX,
          pageY = e.pageY,
          shiftKey = e.shiftKey,
          ctrlKey = e.ctrlKey,
          altKey = e.altKey,
          metaKey = e.metaKey;
      var startMousePos = this.startMousePos,
          data = this.data;
      var currentMousePos = {
        clientX: clientX,
        clientY: clientY,
        pageX: pageX,
        pageY: pageY
      };

      if (this.firstFlag) {
        if (Math.max(Math.abs(startMousePos.clientX - clientX), Math.abs(startMousePos.clientY - clientY)) <= this.dragLimit) {
          return;
        }

        this.handleDragStart(e);
      }

      this.emit('dragging', {
        shiftKey: shiftKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        metaKey: metaKey,
        startMousePos: startMousePos,
        latestMousePos: this.latestMousePos,
        currentMousePos: currentMousePos,
        data: data,
        target: this.getDragElem()
      });
      this.latestMousePos = currentMousePos;
    }
  }, {
    key: "handleDragEnd",
    value: function handleDragEnd(e) {
      if (this.firstFlag) {
        this.handleClick(e);
        return;
      }

      e.stopPropagation();
      var clientX = e.clientX,
          clientY = e.clientY,
          pageX = e.pageX,
          pageY = e.pageY,
          shiftKey = e.shiftKey,
          ctrlKey = e.ctrlKey,
          altKey = e.altKey,
          metaKey = e.metaKey;
      var startMousePos = this.startMousePos,
          latestMousePos = this.latestMousePos,
          data = this.data;
      var currentMousePos = {
        clientX: clientX,
        clientY: clientY,
        pageX: pageX,
        pageY: pageY
      };
      this.emit('drag-end', {
        shiftKey: shiftKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        metaKey: metaKey,
        startMousePos: startMousePos,
        currentMousePos: currentMousePos,
        latestMousePos: latestMousePos,
        data: data,
        target: this.getDragElem()
      });
      currentDragElement = null;
      this.latestMousePos = getDefaultMousePos();
      this.startMousePos = getDefaultMousePos();
      this.firstFlag = false;
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var clientX = e.clientX,
          clientY = e.clientY,
          pageX = e.pageX,
          pageY = e.pageY,
          shiftKey = e.shiftKey,
          ctrlKey = e.ctrlKey,
          altKey = e.altKey,
          metaKey = e.metaKey;
      var startMousePos = this.startMousePos,
          latestMousePos = this.latestMousePos,
          data = this.data;
      var currentMousePos = {
        clientX: clientX,
        clientY: clientY,
        pageX: pageX,
        pageY: pageY
      };
      this.emit('click', {
        shiftKey: shiftKey,
        ctrlKey: ctrlKey,
        altKey: altKey,
        metaKey: metaKey,
        startMousePos: startMousePos,
        currentMousePos: currentMousePos,
        latestMousePos: latestMousePos,
        data: data,
        target: this.getDragElem()
      });
      currentDragElement = null;
      this.latestMousePos = getDefaultMousePos();
      this.startMousePos = getDefaultMousePos();
      this.firstFlag = false;
    }
  }, {
    key: "bindEvent",
    value: function bindEvent(ele) {
      ele.addEventListener('mousedown', this, false);
      ele.addEventListener('click', this, false);
    }
  }, {
    key: "unbindEvent",
    value: function unbindEvent(ele) {
      ele.removeEventListener('mousedown', this, false);
      ele.removeEventListener('click', this, false);
    }
  }, {
    key: "getDragElem",
    value: function getDragElem() {
      if (this.elem == null) {
        throw new Error('call init method first');
      }

      return this.elem;
    }
  }]);

  return Drag;
}(Emitter);

function closest(ele, className) {
  var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var elem = ele;
  context = context || document.body;

  while (elem && elem !== context) {
    if (elem.classList.contains(className)) {
      return elem;
    }

    elem = elem.parentElement;
  }

  return false;
}